import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import PersonIcon from '@mui/icons-material/Person';
import { selectAgentsPinnedFilters, togglePinnedFiltersState } from '@store';
import { useHasFilters } from 'hooks/common';
import { rolesOptions } from '../../components/agents/rolesOptions';

export const useAgentsFilterConfig = () => {
  const router = useRouter();
  const pinnedFilters = useSelector(selectAgentsPinnedFilters);
  const dispatch = useDispatch();

  const roleFilterOptions = useMemo(() => {
    const roles = rolesOptions
      ?.map((item) => ({
        text: item.label,
        value: item.value,
      }))
      .sort((a, b) => a.text.localeCompare(b.text));

    return roles;
  }, []);

  const filterCategories = useMemo(
    () => [
      {
        id: 'role',
        label: 'Role',
        icon: PersonIcon,
        options: roleFilterOptions,
        multiSelect: true,
      },
    ],
    [roleFilterOptions]
  );
  const { hasFilters } = useHasFilters({ pinnedFilters });

  const currentFilters = useMemo(() => {
    const parseQueryValue = (value) => {
      if (!value) return [];
      if (typeof value === 'string') {
        return value.split(',').filter(Boolean);
      }
      return Array.isArray(value) ? value : [];
    };

    return {
      role: parseQueryValue(router.query.role),
    };
  }, [router.query]);

  const handlePinnedFilterSelect = (pinnedFilter) => {
    dispatch(togglePinnedFiltersState({ board: 'agents', pinnedFilter }));
  };

  return {
    filterCategories,
    currentFilters,
    pinnedFilters,
    supportPinnedFilters: true,
    hasFilters,
    handlePinnedFilterSelect,
  };
};
